import { createApp } from '@app/adapters/create-app'
import FirmInboxV2 from '../../screens/inbox/components/firm-inbox-v2'
import createFirmInboxV2Store from '../../screens/inbox/store/firm-inbox-v2'
import { startOnce } from '@app/adapters/tutorial'
import InboxFilters from '@app/application/communication/screens/inbox/components/inbox-filters.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='firm-inbox']").each(function () {
    const endpointParams = {
      firmId: Silverfin.currentFirmId,
    }

    const store = createFirmInboxV2Store({
      ...endpointParams,
      companyNotificationsScope: true,
    })

    const firmInboxApp = createApp(FirmInboxV2)

    firmInboxApp.use(store)
    firmInboxApp.mount(this)

    /* TODO: Manually trigger the corresponding Userlane tutorial until they fix their JS performance
    See https://gitlab.silverfin.com/development/silverfin/-/issues/18067 */
    if (typeof this.dataset.tutorialId !== 'undefined') {
      startOnce(this.dataset.tutorialId)
    }

    $dom.find("[data-behaviour='inbox-filters']").each(function () {
      const filtersApp = createApp(InboxFilters, {
        showAuthorsFilter: false,
        initialSearch: $(this).data('search') || '',
        initialNoteType: $(this).data('noteType') || null,
        initialTags:
          $(this).data('tags')?.toString()?.split(',')?.map(Number.parseInt) ||
          [],
      })

      filtersApp.use(store)
      filtersApp.mount(this)
    })
  })
})
